export default {
  special1:
    'BluePay Company Limited（以下简称“公司”）高度重视客户及用户（以下合称“您”）的隐私及个人信息保护。为确保您能够放心使用由公司提供的电子货币服务、支付服务、电子汇款服务及其他经泰国银行批准的当前及未来可能提供的服务（包括但不限于与公司提供的应用程序、网站及其他渠道使用相关的任何服务，以下合称“服务”）',
  special2:
    '公司制定了本《J&T 钱包功能特别规则》（以下简称“本规则”），作为公司隐私政策的补充，向您说明公司关于收集、使用及披露个人信息的指导原则。本规则与隐私政策共同构成双方就该主题事项的完整协议。除非本规则明确修改并取代隐私政策中的条款和条件，本规则与隐私政策中的条款和条件同等有效并适用。本规则未提及的条款和条件，以隐私政策为准。',
  special3: '隐私政策中的所有条款保持有效。',
  special4: '公司将按照隐私政策收集、使用、处理或披露数据。此外，公司还将进一步收集以下信息：',
  special5: '金融信息：包括但不限于您的账户余额、银行信息以及您的交易记录等。',
  special6: '技术信息：包括但不限于您允许公司向您发送与您的账户和交易相关的通知的信息。',
  special7:
    '公司可能会从您处收集和/或使用、发送、转移、处理和/或向 Global Jet Express (Thailand) Co., Ltd. 以及隐私政策中提及的人员披露数据。本规则旨在补充隐私政策，为您提供更全面的保护。在使用 J&T 钱包功能时，您应同时遵守隐私政策和本规则的规定。'
}
